import { Component, OnInit } from '@angular/core';
import { Code } from './../../code/tabs';
@Component({
  templateUrl: './tabsview.component.html'
})
export class TabsviewComponent implements OnInit {

	code = Code;
	checked1: boolean = false;
	checked2: boolean = true;

	parameters: any[];
	paramesubters: any[];
	eventHeader: any[];
	eventValue: any[];
	styleHeader: any[];
	styleValue: any[];
	items: any[]; 
	headers: any[];
	constructor() { }
	msgs: any[];

	onTabChange(event) {
		alert("Index: " + event.index);
	}

	ngOnInit() {
		this.items = [
		    {label: 'Update', icon: 'fa ion-refresh', command: () => {
		        console.log(1)
		    }},
		    {label: 'Delete', icon: 'fa ion-close', command: () => {
		        console.log(2)
		    }},
		    {label: 'Angular.io', icon: 'fa-link', url: 'http://angular.io'},
		    {label: 'Theming', icon: 'fa-paint-brush', routerLink: ['/theming']}
		];
		this.parameters = [
		    {name: "orientation",type: "string",default: "top",des: "标签标题的定位。"},
		    {name: "activeIndex",type: "number",default: "null",des: "活动选项卡的索引以编程方式更改选定的选项卡。"},
		    {name: "style",type: "string",default: "null",des: "组件行内样式。"},
		    {name: "styleClass",type: "string",default: "null",des: "组件的样式类。"}
		];

		this.paramesubters = [
			{name: "header",type: "string",default: "null",des: "标签标题的定位。"},
		    {name: "selected",type: "boolean",default: "false",des: "定义是否激活标签。"},
		    {name: "disabled",type: "boolean",default: "false",des: "如果为true，则无法激活Tab。"},
		    {name: "closable",type: "boolean",default: "false",des: "定义是否可以删除制表符。"},
		    {name: "headerStyle",type: "string",default: "null",des: "选项卡标题的内联样式。"},
		    {name: "headerStyleClass",type: "number",default: "null",des: "Tab标头的样式类。"},
		    {name: "controlClose",type: "string",default: "false",des: "是否在关闭事件控制Tabor关闭。"},
		    {name: "cache",type: "boolean",boolean: "true",des: "延迟加载的面板是否应避免重新加载"}
		];

		this.headers = [
		    {name : "名字"},
		    {name : "类型"},
		    {name : "默认"},
		    {name : "描述"}
		];

		this.eventHeader = [
			{name : "名字"},
		    {name : "参数"},
		    {name : "描述"}
		];

		this.eventValue = [
			{name : "onChange",param : "1.事件：点击事件 2.事件索引：选定选项卡的索引",event :"在选项卡更改中调用。" },
			{name : "onClose",param : "1.事件：点击事件 2.事件索引：关闭选项卡的索引 3.关闭事件：回调实际关闭制表符，仅在控件时可用",event :"回调在Tabor关闭时调用。" }
		];

		this.styleHeader = [
			{name : "名字"},
		    {name : "元素"}
		];

		this.styleValue = [
			{name : "ui-tabview",el : "容器元素。"},
			{name : "ui-tabview-nav",el : "页眉容器。"},
			{name : "ui-tabview-selected",el : "选定的选项卡标题。"},
			{name : "ui-tabview-panels",el : "集装箱面板。"},
			{name : "ui-tabview-panel",el : "选项卡的内容。"}
		];
	}

}



// WEBPACK FOOTER //
// ./src/app/view/tabsview/tabsview.component.ts